module.exports = {
	// baseUrl: 'https://aptmining.com',
	// baseImageUrl: 'https://aptmining.com',
	baseUrl: document.location.protocol+"//"+document.location.host,
	baseImageUrl: document.location.protocol+"//"+document.location.host,
}